import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CONSTANTS } from "../constants";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { NotificationService } from ".";

@Injectable() 
export class HttpService {
    private headers: HttpHeaders;

    private authHeaderName: string = "Authorization";

    constructor(private http: HttpClient,
        private notificationService: NotificationService,
        private router: Router) {
            this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    }

    tryAddAuthorizationHeader() {
        this.headers = this.headers.delete(this.authHeaderName);
        
        let token = localStorage.getItem(CONSTANTS.cacheKeys.token);

        if(token) {
            this.headers = this.headers.append(this.authHeaderName,`${token}`)
        }
    }

    get<ResponseModel>(apiUrl: string, params: HttpParams, shouldHandleError = true): Observable<ResponseModel> {
        this.tryAddAuthorizationHeader();

        let options = {
            headers: this.headers,
            params: params 
        };
        
        return this.http.get<ResponseModel>(apiUrl, options)
        .pipe(
            catchError(error => {
                if (shouldHandleError) {
                    this.handleError(error);
                }
                return throwError(error);
            }),
            map(res => {
                this.refreshSessionTimer(this.headers);
                return res;
            }));
    }

    put<ResponseModel>(apiUrl: string, params: HttpParams, body: any, shouldHandleError = true): Observable<ResponseModel> {
        this.tryAddAuthorizationHeader();

        let options = {
            headers: this.headers,
            params: params 
        };
        
        return this.http.put<ResponseModel>(apiUrl, body, options)
        .pipe(
            catchError(error => {
                if (shouldHandleError) {
                    this.handleError(error);
                }
                return throwError(error);
            }),
            map(res => {
                this.refreshSessionTimer(this.headers);
                return res;
            }));
    }

    post<ResponseModel>(apiUrl: string, params: HttpParams, body: any, shouldHandleError = true): Observable<ResponseModel> {
        this.tryAddAuthorizationHeader();

        let options = {
            headers: this.headers,
            params: params 
        };
        
        return this.http.post<ResponseModel>(apiUrl, body, options)
        .pipe(
            catchError(error => {
                if (shouldHandleError) {
                    this.handleError(error);
                }
                return throwError(error);
            }),
            map(res => {
                this.refreshSessionTimer(this.headers);
                return res;
            }));
    }


    private handleError(error){
        switch (error.status) {
            case 502:
                this.notificationService.showError(CONSTANTS.httpErrorCodes.status502);
            break;
            case 503:
                this.notificationService.showError(CONSTANTS.httpErrorCodes.status502);
            break;
            case 404:
                this.notificationService.showError(CONSTANTS.httpErrorCodes.status404);
            break;
            case 403:
                this.notificationService.showError(CONSTANTS.httpErrorCodes.status403);
            break;
            case 401:
                this.router.navigate(['login']);
            break;
        }
    }

    private refreshSessionTimer(headers: HttpHeaders) {
        if (headers.get(this.authHeaderName)) {
            //this.sessionService.setSessionTimer();
        }
    }
}